import { COLORS } from "../theme";
import { useSelector } from "react-redux";
import { getQFuserMode } from "../store/components";
import { getBrokerInformation } from "../store/broker";
import { useNavigate } from "react-router-dom";
const QuoteyBrand = (props) => {
  const qfUserMode = useSelector(getQFuserMode);
  const BrokerInfo = useSelector(getBrokerInformation);
  const navigate = useNavigate();
  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        color: "white",
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
      }}
      onClick={() => {
        if (qfUserMode !== "client") {
          document.location.href = "/";
        }
        //navigate("/")
      }}
    >
      {qfUserMode == "client" ? (
        <span
          style={{
            color: "white",
            fontFamily: "sans-serif",
            fontWeight: "bold",
            fontSize: "19px",
            marginLeft: "1%",
            paddingLeft: "40px",
          }}
        >
          {" "}
          {BrokerInfo.brokerageImg?.name}
        </span>
      ) : (
        <QuoteyTextSVG color={"white"}></QuoteyTextSVG>
      )}
    </div>
  );
};

export const QuoteyBrandForPDF = () => {
  return (
    <div
      style={{
        color: "white",
        fontFamily: "GibsonBold",
        fontSize: 22,
        letterSpacing: 2,
        justifyContent: "flex-start",
      }}
    >
      QUOTEY
    </div>
  );
};

export const QuoteyTextSVG = ({ color }) => (
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 720 360"
    xmlSpace="preserve"
    // style={{
    //   border: "5px solid black",
    //   // width: "100%",
    //   // height: "100%",
    // }}
  >
    <g>
      <g>
        <path
          fill={color}
          d="M236.9,137.8c-6-3.2-12.7-4.8-20.2-4.8c-7.5,0-14.2,1.6-20.2,4.8c-6,3.2-10.7,7.7-14.1,13.3
			c-3.4,5.7-5.1,12-5.1,19.1c0,7.1,1.7,13.4,5.1,19.1c3.4,5.7,8.1,10.1,14.1,13.3c4.3,2.3,9,3.8,14.1,4.4v0l30.1,9.2l-8.9-11.4
			c1.7-0.6,3.4-1.4,5.1-2.3c6-3.2,10.7-7.7,14.1-13.3c3.4-5.7,5.1-12,5.1-19.1c0-7.1-1.7-13.4-5.1-19.1
			C247.5,145.5,242.8,141.1,236.9,137.8z M236.3,182.2c-2,3.5-4.6,6.2-8.1,8.2c-3.4,2-7.3,2.9-11.5,2.9c-4.3,0-8.1-1-11.5-2.9
			c-3.4-2-6.1-4.7-8.1-8.2c-2-3.5-2.9-7.5-2.9-11.9c0-4.5,1-8.4,2.9-11.9c2-3.5,4.6-6.2,8.1-8.2c3.4-2,7.3-2.9,11.5-2.9
			c4.3,0,8.1,1,11.5,2.9c3.4,2,6.1,4.7,8.1,8.2c2,3.5,2.9,7.5,2.9,11.9C239.2,174.7,238.3,178.7,236.3,182.2z"
        />
      </g>
      <g>
        <path
          fill={color}
          d="M302.3,178.3c0,4.9-1.2,8.7-3.5,11.2c-2.3,2.5-5.4,3.8-9.3,3.8c-7.5,0-11.2-4.5-11.2-13.4v-28.9h-16v31.3
			c0,8.2,2.1,14.4,6.4,18.6c4.3,4.2,10,6.3,17.3,6.3c3.4,0,6.6-0.6,9.6-1.9c2.9-1.3,5.5-3.1,7.6-5.5v6.6h15.2v-55.3h-16V178.3z"
        />
      </g>
      <g>
        <path
          fill={color}
          d="M370.3,153.7c-4.6-2.4-9.8-3.7-15.6-3.7c-5.8,0-11.1,1.2-15.7,3.7c-4.6,2.4-8.2,5.8-10.9,10.1
			c-2.6,4.3-3.9,9.2-3.9,14.7c0,5.5,1.3,10.4,3.9,14.7c2.6,4.3,6.2,7.7,10.9,10.1c4.6,2.4,9.9,3.7,15.7,3.7c5.8,0,11-1.2,15.6-3.7
			c4.6-2.4,8.2-5.8,10.8-10.1c2.6-4.3,3.9-9.2,3.9-14.7c0-5.5-1.3-10.4-3.9-14.7C378.5,159.5,374.9,156.2,370.3,153.7z M364.8,189.7
			c-2.6,2.8-6,4.2-10.1,4.2c-4.1,0-7.5-1.4-10.2-4.2c-2.7-2.8-4-6.5-4-11.2c0-4.7,1.3-8.4,4-11.2c2.7-2.8,6.1-4.2,10.2-4.2
			c4.1,0,7.5,1.4,10.1,4.2c2.6,2.8,4,6.5,4,11.2C368.7,183.2,367.4,186.9,364.8,189.7z"
        />
      </g>
      <g>
        <path
          fill={color}
          d="M415.6,194.3c-2.2,0-3.9-0.6-5.1-1.9c-1.2-1.3-1.8-3.1-1.8-5.4v-22.5h13.8v-12.3h-13.8v-13.5h-16v13.5h-8.5
			v12.3h8.5v22.7c0,6.5,1.8,11.5,5.4,14.8c3.6,3.4,8.7,5,15.3,5c2.5,0,5-0.3,7.3-0.9c2.3-0.6,4.2-1.5,5.8-2.6l-4.3-11.3
			C420.3,193.6,418.2,194.3,415.6,194.3z"
        />
      </g>
      <g>
        <path
          fill={color}
          d="M464.4,192.9c-2.2,0.9-4.8,1.3-7.7,1.3c-4.2,0-7.7-1-10.5-3c-2.8-2-4.6-4.7-5.3-8.1h41.9
			c0.2-2.7,0.3-4.1,0.3-4.3c0-5.8-1.3-10.8-3.8-15.2c-2.5-4.4-5.9-7.7-10.3-10c-4.4-2.3-9.3-3.5-14.7-3.5c-5.6,0-10.6,1.2-15.1,3.7
			c-4.5,2.4-8,5.8-10.6,10.2c-2.6,4.4-3.9,9.2-3.9,14.7c0,5.5,1.3,10.4,3.9,14.7c2.6,4.3,6.3,7.7,11.1,10.1
			c4.8,2.4,10.3,3.7,16.6,3.7c10,0,17.6-3,22.8-8.9l-8.5-9.3C468.7,190.7,466.6,192.1,464.4,192.9z M445.2,165.3
			c2.5-2.1,5.5-3.1,9.2-3.1c3.6,0,6.6,1,9.1,3.1c2.5,2.1,4,4.9,4.5,8.4h-27.3C441.2,170.2,442.7,167.3,445.2,165.3z"
        />
      </g>
      <g>
        <path
          fill={color}
          d="M527.3,150.9l-15.6,37.5l-15.5-37.5h-16.6l24,55.8l-0.2,0.5c-1.1,2.5-2.3,4.2-3.7,5.3
			c-1.4,1.1-3.2,1.6-5.3,1.6c-1.6,0-3.2-0.3-4.8-0.9c-1.6-0.6-3-1.5-4.3-2.6l-5.9,11.4c1.8,1.6,4.1,2.8,6.9,3.7
			c2.8,0.9,5.7,1.3,8.5,1.3c5.3,0,9.8-1.3,13.5-3.9c3.7-2.6,6.9-7.1,9.4-13.5l25-58.7H527.3z"
        />
      </g>
    </g>
  </svg>
);

//#region Experiment
export const QWordSvg = ({ color }) => (
  <svg
    version="1.1"
    id="Layer_1"
    style={{ border: "5px solid black", width: "30%", height: "30%" }}
  >
    <g>
      <g>
        <path
          x="100"
          y="100"
          width={100}
          height="100"
          fill={color}
          d="M236.9,137.8c-6-3.2-12.7-4.8-20.2-4.8c-7.5,0-14.2,1.6-20.2,4.8c-6,3.2-10.7,7.7-14.1,13.3
			c-3.4,5.7-5.1,12-5.1,19.1c0,7.1,1.7,13.4,5.1,19.1c3.4,5.7,8.1,10.1,14.1,13.3c4.3,2.3,9,3.8,14.1,4.4v0l30.1,9.2l-8.9-11.4
			c1.7-0.6,3.4-1.4,5.1-2.3c6-3.2,10.7-7.7,14.1-13.3c3.4-5.7,5.1-12,5.1-19.1c0-7.1-1.7-13.4-5.1-19.1
			C247.5,145.5,242.8,141.1,236.9,137.8z M236.3,182.2c-2,3.5-4.6,6.2-8.1,8.2c-3.4,2-7.3,2.9-11.5,2.9c-4.3,0-8.1-1-11.5-2.9
			c-3.4-2-6.1-4.7-8.1-8.2c-2-3.5-2.9-7.5-2.9-11.9c0-4.5,1-8.4,2.9-11.9c2-3.5,4.6-6.2,8.1-8.2c3.4-2,7.3-2.9,11.5-2.9
			c4.3,0,8.1,1,11.5,2.9c3.4,2,6.1,4.7,8.1,8.2c2,3.5,2.9,7.5,2.9,11.9C239.2,174.7,238.3,178.7,236.3,182.2z"
        />
      </g>
    </g>
  </svg>
);
export const QuoteyTextSVGExperiment = ({
  color,
  height = 15,
  heightUnit = "vw",
}) => (
  <svg
    version="1.1"
    id="Layer_1"
    // viewBox="150 120 500 120"
    // viewBox="100 100 550 250"
    viewBox="165 150 400 50"
    style={{
      border: "5px solid black",
      width: `calc(2 * ${height}${heightUnit})`,
      height: `calc(${height}${heightUnit} - ${
        (4 * height) / 14
      }${heightUnit})`,
    }}
  >
    <g>
      <g>
        <path
          fill={color}
          d="M236.9,137.8c-6-3.2-12.7-4.8-20.2-4.8c-7.5,0-14.2,1.6-20.2,4.8c-6,3.2-10.7,7.7-14.1,13.3
			c-3.4,5.7-5.1,12-5.1,19.1c0,7.1,1.7,13.4,5.1,19.1c3.4,5.7,8.1,10.1,14.1,13.3c4.3,2.3,9,3.8,14.1,4.4v0l30.1,9.2l-8.9-11.4
			c1.7-0.6,3.4-1.4,5.1-2.3c6-3.2,10.7-7.7,14.1-13.3c3.4-5.7,5.1-12,5.1-19.1c0-7.1-1.7-13.4-5.1-19.1
			C247.5,145.5,242.8,141.1,236.9,137.8z M236.3,182.2c-2,3.5-4.6,6.2-8.1,8.2c-3.4,2-7.3,2.9-11.5,2.9c-4.3,0-8.1-1-11.5-2.9
			c-3.4-2-6.1-4.7-8.1-8.2c-2-3.5-2.9-7.5-2.9-11.9c0-4.5,1-8.4,2.9-11.9c2-3.5,4.6-6.2,8.1-8.2c3.4-2,7.3-2.9,11.5-2.9
			c4.3,0,8.1,1,11.5,2.9c3.4,2,6.1,4.7,8.1,8.2c2,3.5,2.9,7.5,2.9,11.9C239.2,174.7,238.3,178.7,236.3,182.2z"
        />
      </g>
      <g>
        <path
          fill={color}
          d="M302.3,178.3c0,4.9-1.2,8.7-3.5,11.2c-2.3,2.5-5.4,3.8-9.3,3.8c-7.5,0-11.2-4.5-11.2-13.4v-28.9h-16v31.3
			c0,8.2,2.1,14.4,6.4,18.6c4.3,4.2,10,6.3,17.3,6.3c3.4,0,6.6-0.6,9.6-1.9c2.9-1.3,5.5-3.1,7.6-5.5v6.6h15.2v-55.3h-16V178.3z"
        />
      </g>
      <g>
        <path
          fill={color}
          d="M370.3,153.7c-4.6-2.4-9.8-3.7-15.6-3.7c-5.8,0-11.1,1.2-15.7,3.7c-4.6,2.4-8.2,5.8-10.9,10.1
			c-2.6,4.3-3.9,9.2-3.9,14.7c0,5.5,1.3,10.4,3.9,14.7c2.6,4.3,6.2,7.7,10.9,10.1c4.6,2.4,9.9,3.7,15.7,3.7c5.8,0,11-1.2,15.6-3.7
			c4.6-2.4,8.2-5.8,10.8-10.1c2.6-4.3,3.9-9.2,3.9-14.7c0-5.5-1.3-10.4-3.9-14.7C378.5,159.5,374.9,156.2,370.3,153.7z M364.8,189.7
			c-2.6,2.8-6,4.2-10.1,4.2c-4.1,0-7.5-1.4-10.2-4.2c-2.7-2.8-4-6.5-4-11.2c0-4.7,1.3-8.4,4-11.2c2.7-2.8,6.1-4.2,10.2-4.2
			c4.1,0,7.5,1.4,10.1,4.2c2.6,2.8,4,6.5,4,11.2C368.7,183.2,367.4,186.9,364.8,189.7z"
        />
      </g>
      <g>
        <path
          fill={color}
          d="M415.6,194.3c-2.2,0-3.9-0.6-5.1-1.9c-1.2-1.3-1.8-3.1-1.8-5.4v-22.5h13.8v-12.3h-13.8v-13.5h-16v13.5h-8.5
			v12.3h8.5v22.7c0,6.5,1.8,11.5,5.4,14.8c3.6,3.4,8.7,5,15.3,5c2.5,0,5-0.3,7.3-0.9c2.3-0.6,4.2-1.5,5.8-2.6l-4.3-11.3
			C420.3,193.6,418.2,194.3,415.6,194.3z"
        />
      </g>
      <g>
        <path
          fill={color}
          d="M464.4,192.9c-2.2,0.9-4.8,1.3-7.7,1.3c-4.2,0-7.7-1-10.5-3c-2.8-2-4.6-4.7-5.3-8.1h41.9
			c0.2-2.7,0.3-4.1,0.3-4.3c0-5.8-1.3-10.8-3.8-15.2c-2.5-4.4-5.9-7.7-10.3-10c-4.4-2.3-9.3-3.5-14.7-3.5c-5.6,0-10.6,1.2-15.1,3.7
			c-4.5,2.4-8,5.8-10.6,10.2c-2.6,4.4-3.9,9.2-3.9,14.7c0,5.5,1.3,10.4,3.9,14.7c2.6,4.3,6.3,7.7,11.1,10.1
			c4.8,2.4,10.3,3.7,16.6,3.7c10,0,17.6-3,22.8-8.9l-8.5-9.3C468.7,190.7,466.6,192.1,464.4,192.9z M445.2,165.3
			c2.5-2.1,5.5-3.1,9.2-3.1c3.6,0,6.6,1,9.1,3.1c2.5,2.1,4,4.9,4.5,8.4h-27.3C441.2,170.2,442.7,167.3,445.2,165.3z"
        />
      </g>
      <g>
        <path
          fill={color}
          d="M527.3,150.9l-15.6,37.5l-15.5-37.5h-16.6l24,55.8l-0.2,0.5c-1.1,2.5-2.3,4.2-3.7,5.3
			c-1.4,1.1-3.2,1.6-5.3,1.6c-1.6,0-3.2-0.3-4.8-0.9c-1.6-0.6-3-1.5-4.3-2.6l-5.9,11.4c1.8,1.6,4.1,2.8,6.9,3.7
			c2.8,0.9,5.7,1.3,8.5,1.3c5.3,0,9.8-1.3,13.5-3.9c3.7-2.6,6.9-7.1,9.4-13.5l25-58.7H527.3z"
        />
      </g>
    </g>
  </svg>
);
//#endregion

export default QuoteyBrand;
